export default "__VITE_ASSET__2f47361b__"